const COGNITO_STORAGE_PREFIX = 'CognitoIdentityServiceProvider';

// Só a sessão do app client deste ambiente conta. Sandbox e produção dividem
// os cookies de `.abbiamolog.com`, e a sessão de produção fazia o sandbox
// achar que estava logado e cair no fluxo de sessão perdida.
const sessionKeyPrefix = (): string => {
  const clientId = process.env['NX_COGNITO_USER_POOL_WEB_CLIENT_ID'];
  return clientId
    ? `${COGNITO_STORAGE_PREFIX}.${clientId}.`
    : COGNITO_STORAGE_PREFIX;
};

const storageHasCognitoSession = (storage?: Storage): boolean => {
  if (!storage) return false;

  const prefix = sessionKeyPrefix();
  for (let i = 0; i < storage.length; i += 1) {
    const key = storage.key(i);
    if (key?.startsWith(prefix)) return true;
  }

  return false;
};

const cookiesHaveCognitoSession = (): boolean => {
  if (typeof document === 'undefined') return false;

  const prefix = sessionKeyPrefix();
  return document.cookie
    .split('; ')
    .some((part) => part.startsWith(prefix));
};

export const hasCachedCognitoSession = (): boolean => {
  if (typeof window === 'undefined') return false;

  return (
    storageHasCognitoSession(window.localStorage) ||
    storageHasCognitoSession(window.sessionStorage) ||
    cookiesHaveCognitoSession()
  );
};
